export const ChartProductUsageSkeleton = () => {
  return (
    <div
      className="grid grid-cols-1 gap-x-5 gap-y-4 sm:grid-cols-2 lg:grid-cols-3"
      data-testid="chart-product-usage-skeleton"
    >
      {Array.from({ length: 6 }).map((_, index) => (
        <div
          key={index}
          className="h-[119px] rounded-3xl bg-gray-200 animate-pulse"
        />
      ))}
    </div>
  );
};
